/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { externalCredentialsList } from "../funcs/externalCredentialsList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListExternalCredentialsResult } from "../models/components/listexternalcredentialsresult.js";
import {
  ListExternalCredentialsRequest,
  ListExternalCredentialsSecurity,
  QueryParamProvider,
} from "../models/operations/listexternalcredentials.js";
import { unwrapAsync } from "../types/fp.js";
export type ListExternalCredentialsQueryData = ListExternalCredentialsResult;

export function prefetchListExternalCredentials(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListExternalCredentialsRequest | undefined,
  security?: ListExternalCredentialsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildListExternalCredentialsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildListExternalCredentialsQuery(
  client$: GramCore,
  request?: ListExternalCredentialsRequest | undefined,
  security?: ListExternalCredentialsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<ListExternalCredentialsQueryData>;
} {
  return {
    queryKey: queryKeyListExternalCredentials({
      provider: request?.provider,
      gramSession: request?.gramSession,
    }),
    queryFn: async function listExternalCredentialsQueryFn(
      ctx,
    ): Promise<ListExternalCredentialsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(externalCredentialsList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyListExternalCredentials(
  parameters: {
    provider?: QueryParamProvider | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "externalCredentials", "list", parameters];
}
